import { InlineSvg } from 'components/svg';
import { useIframeDialogStore } from 'widgets/iframe-dialog/model/iframe-dialog-store';

export const ModalHeader = () => {
  const { close } = useIframeDialogStore();
  return (
    <div className="modal-header mb-0 p-0 border-0">
      {/* begin::Modal title */}
      <h2 className="fw-bolder"></h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-employees-modal-action="close"
        onClick={() => close()}
        style={{ cursor: 'pointer' }}
      >
        <InlineSvg path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};
